import { render, staticRenderFns } from "./upcAdministration.vue?vue&type=template&id=da665452&scoped=true&"
import script from "./upcAdministration.vue?vue&type=script&lang=js&"
export * from "./upcAdministration.vue?vue&type=script&lang=js&"
import style0 from "./upcAdministration.vue?vue&type=style&index=0&id=da665452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da665452",
  null
  
)

export default component.exports